<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-8">
          <h3>Om Livet i havet</h3>
          <p>
            Livet i havet är en digital fälthandbok om växter och djur i svenska
            havsområden. Sidan drivs av
            <a
              :class="{ 'disabled-click': $_kioskMode || isOffline }"
              href="https://www.su.se/ostersjocentrum/"
              target="_blank"
              style="color: rgba(255, 255, 255, 0.6);"
              >Stockholms universitet</a
            >
            och
            <a
              :class="{ 'disabled-click': $_kioskMode || isOffline }"
              href="https://havochsamhalle.gu.se/"
              target="_blank"
              style="color: rgba(255, 255, 255, 0.6);"
              >Göteborgs universitet</a
            >
            och i samverkan med webbyrån
            <a
              :class="{ 'disabled-click': $_kioskMode || isOffline }"
              href="https://www.azote.se"
              target="_blank"
              style="color: rgba(255, 255, 255, 0.6);"
              >Azote</a
            >.
            <a
              href="https://www.havet.nu/livet/om-livet"
              target="_blank"
              class=" "
              >Läs mer <i class="fa fa-arrow-circle-right"></i
            ></a>
          </p>
        </div>
        <div class="col-sm-4">
          <h3>Kontakta oss</h3>
          <p>
            <v-icon color="white" class="mr-2">mdi-email</v-icon>
            <a
              href="mailto:redaktionen@havet.nu"
              :class="{ 'disabled-click': $_kioskMode || isOffline }"
              >redaktionen@havet.nu</a
            >
          </p>
          <p>
            <v-icon color="white" class="mr-2">mdi-instagram</v-icon>
            <a
              :class="{ 'disabled-click': $_kioskMode || isOffline }"
              href="https://www.instagram.com/livihavet/"
              target="_blank"
              class=""
              >livihavet</a
            >
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12"><hr /></div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <p>
            Texterna är skrivna av redaktörerna tillsammans med forskare och
            experter. Bilderna är upphovsrättsskyddade, men texterna får
            användas fritt i icke-kommersiella syften så länge Livet i havet
            anges som källa.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12"><hr /></div>
      </div>
      <div class="row justify-center align-center">
        <div class="col-sm-4 sulogo justify-center">
          <a
            target="_blank"
            href="https://www.su.se/ostersjocentrum/"
            :class="{ 'disabled-click': $_kioskMode || isOffline }"
          >
            <v-img
              contain
              max-height="100"
              max-width="300"
              src="/img/logo_su.png"
            ></v-img>
          </a>
        </div>
        <div class="col-sm-4 gulogo justify-center">
          <a
            target="_blank"
            :class="{ 'disabled-click': $_kioskMode || isOffline }"
            href="https://havochsamhalle.gu.se/"
          >
            <v-img
              contain
              max-height="100"
              max-width="280"
              src="/img/logo_gu.png"
            ></v-img>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Misc from '@/mixins/Misc.js'

export default {
  name: 'Footer',
  mixins: [Misc]
}
</script>

<style lang="css" scoped>
.sulogo,
.uulogo,
.gulogo,
.slulogo,
.havinstlogo {
  display: flex;
}
.footer {
  background-color: #21a261;
  padding-top: 50px;
  padding-bottom: 50px;
}
.footer p,
.footer h3 {
  color: #fff;
}
a {
  color: #fff !important;
}
.disabled-click {
  pointer-events: none;
  cursor: default;
}
</style>
